export const initialValues = {
  board_id: '',
  level: 1,
  proc_hierarchy_id: '',
  name: '',
  output: '',
  objective: '',
  competency_type: '',
  competency_name: '',
  competency_level: '',
  level_description: '',
  parent_id: '',
  parent_id_label: '',
  main_indicator: '',
  func_competencies: [],
  dataWorkload: [],
  behaviour_comp: [],
  type_process_parent: '',
};
